<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader.vue";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxGroupPanel, DxGrouping, DxFilterRow,
  DxPager, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import DropZone from "@/components/widgets/dropZoneCsv.vue";
import {ref} from "vue";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: {
    DropZone, Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn,
    DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxGroupPanel, DxGrouping, DxFilterRow,
    DxToolbar, DxItem, DxPager,  DxRemoteOperations,
    Loader
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop};
  },

  data() {

    return {
      title: "Pedidos Shopee",
      items: [
        {
          text: "Pedidos",
          href: "/"
        },
        {
          text: "Pedidos Shopee",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,

      errosValid: null,
      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,
      showModalImpPlan: false,
      submittedImpPlan: false,
      showModalConsShopee: false,
      updating: false,
      updatingShopee: false,
      arqDispDownload: false,
      movShopeeTrkData: {},
      movSpeTrkFinancs: null,

      showModalPerFecha: false,
      submittedPerFecha: false,
      dtIniPerFecha: null,
      dtFimPerFecha: null,
    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov_shopee-list_0')
    this.atualizaDataList()
  },

  methods: {

    confirmarPerFecha(){
      console.log('confirmarPerFecha')
      this.submittedPerFecha = true
      if (this.dtIniPerFecha && this.dtFimPerFecha) {
        this.showModalPerFecha = false
        let listaNotas = this.dataGrid.getSelectedRowKeys()
        this.updating = true
        api.get(`${getBaseUrl()}api/movshptrkgfin`,{
          params: {
            'ids': listaNotas,
            'dtini': moment(this.dtIniPerFecha).format('YYYY-MM-DD'),
            'dtfim': moment(this.dtFimPerFecha).format('YYYY-MM-DD')
          }
        }).then(response => {
          console.log(response.data)
          this.updating = false
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            html: response.data['contLancs'] + ' Lançamentos selecionados <br>'
                + response.data['contSemMotor'] + ' Não possuiam motorista ou veículo <br>'
                + response.data['totalCriado'] + ' Registros financeiros criados com sucesso',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 4000
          }).then(() => {
            window.location.reload();
          })
        })
      }
    },


    abrirFinanceiro(){
      console.log('abrirFinanceiro')
      const routeData = this.$router.resolve(`/movshptrkfins/list`)
      window.open(routeData.href, '_blank')
    },


    criarFinanceiro(){
      console.log('criarFinanceiro_0')
      let listaNotas = this.dataGrid.getSelectedRowKeys()
      console.log('listaNotas')
      console.log(listaNotas.length)
      if (listaNotas.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: 'Nenhum lançamento selecionado, favor selecionar e tentar novamente.',
          showConfirmButton: false,
          timer: 2500
        })
      } else {
        this.showModalPerFecha = true
      }
    },


    nomeStatus(e) {
      if (e.value === "CO") {
        return 'Coletado (CO)'
      } else if (e.value === "RE") {
        return 'Rota Entrega (RE)'
      }
    },

    downloadArq(){
      console.log('downloadArq')
      console.log(this.movShopeeTrkData)
      const path = 'public/uploads/xmls_shopeetrk/' + this.movShopeeTrkData.pedido + '.xml'

      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: { pathData: path }
      }).then((res) => {
        console.log('res down')
        console.log(res)

        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'cte_pedido_' + this.movShopeeTrkData.pedido + '.xml');
        document.body.appendChild(fileLink);

        console.log('fileLink')
        console.log(fileURL)

        fileLink.click();
        this.loadingFiles = false
      })

    },


    novaImpPlan(){
      console.log('novaImpPlan')
      this.submittedImpPlan = false
      this.showModalImpPlan = true
    },

    confImpPlan(){
      console.log('confImpPlan')
      this.submittedImpPlan = true
      this.updating = true
      if (this.dropzoneFile.name){
        this.showModalImpPlan = false
        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)
        api.post(`${getBaseUrl()}api/movshptrkimpcsv`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.mediasData = res.data[0]
          this.loadingFiles = false
          if (res.data[0] === 'erro') {
            Swal.fire({
              position: "top-end",
              icon: `error`,
              title: `Erro ao importar planilha tipo ${res.data[1]}, revisar colunas:`,
              text: res.data[2],
              showConfirmButton: true,
            }).then(() => {
              this.updating = false
            })
          } else {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações importadas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(res => {
              console.log(res)
              this.atualizaDataList()
            })
          }
        }).catch((err) => {
          console.log('erro axios_0')
          console.log(err)
          console.log('erro axios_1')
          console.log(err.response)
          console.log('erro axios_2')
          //console.log(err.response.status)
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: 'Tamanho máximo atingigo, favor reduzir o tamanho do arquivo ou entrar em contato com suporte',
            text: err,
            showConfirmButton: true,
          }).then(() => {
            this.updating = false
          })

        })
      }
    },

    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))
      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    carregouGrid(e){
      console.log('carregouGrid')
      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
      this.title = `(${e.component.totalCount()}) Pedidos Shopee: ${dtIniFormated} - ${dtFimFormated}`
    },


    atualizaDataList(){
      console.log('atualizaDataList_mov')
      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      this.updating = false

      let hoje = moment()
      hoje.add(-30, 'days')
      const dia = hoje.date()
      this.dtIniPerFecha = hoje.clone().date(dia < 15 ? 1 : 15).startOf('day').format('YYYY-MM-DD')
      this.dtFimPerFecha = hoje.clone().date(dia < 16 ? 15 : hoje.daysInMonth()).format('YYYY-MM-DD')

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }

          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/movsshopeetrk`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data_0')
            console.log(response.data[0])

            response.data[0].forEach((pedido) => {
              if (pedido.inicio){
                pedido.inicio = moment(pedido.inicio).format('DD/MM/YYYY HH:mm')
              }
              if (pedido.entrega){
                pedido.entrega = moment(pedido.entrega).format('DD/MM/YYYY HH:mm')
              }
            })

            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },

    consShopee(idMov){
      console.log('consShopee')
      this.updatingShopee = true
      api.get(`${getBaseUrl()}api/movshptrkcons`, {
        params: { id: idMov }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.updatingShopee = false
        if(res.data[0] === 'erro') {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: res.data[1],
            showConfirmButton: false,
            timer: 2500
          })
        } else {

          if (res.data[0].id) {
            const routeData = this.$router.resolve(`/movcte/editar/${res.data[0].id}`)
            window.open(routeData.href, '_blank')
          }

          this.arqDispDownload = true
          let test = []
          test.push(res.data[0])
          localStorage.setItem('impxml', JSON.stringify(res.data))
          const routeData = this.$router.resolve({  name: 'MovCteImpXML', params: { id: '0' }, query: {impobj: 'true'}})
          window.open(routeData.href, '_blank')

        }
      })
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      api.get(`${getBaseUrl()}api/movshptrkfin`,{
        params: {
          'iddata': idData
        }
      }).then(response => {
        console.log(response.data)
        this.showModalConsShopee = true
        this.movShopeeTrkData = row.data
        this.movSpeTrkFinancs = response.data[0]

      })
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "mov_status") {
          const valStatus = e.data.mov_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CF':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'ENP':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'ECR':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'EAT':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'NED':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'NEF':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SCT':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'CCT':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'TRA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'CAN':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "diasentrega") {
          const valDias = e.data.diasentrega
          let corDias = null
          if (!valDias) {
            corDias = 'rgba(0,0,0,0.38)'
          } else if (valDias < 0) {
            corDias = 'rgba(146,20,0,0.5)'
          } else if (valDias > 0) {
            corDias = 'rgba(33,78,0,0.5)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corDias}`;
        }


      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },


    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"  @click="showModalPeriodo = true"/>

    <div>
      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="upload"
              text="Importar Arquivo"
              type="normal"
              :on-click="novaImpPlan"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="money"
              text="Criar Financeiro"
              :on-click="criarFinanceiro"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="checklist"
              text="Abrir Financeiro"
              :on-click="abrirFinanceiro"/>
        </DxItem>

      </DxToolbar>
    </div>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">
      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>


        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            data-field="taskid"
            caption="Task ID"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="motorista"
            caption="Motorista"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="motorid"
            caption="Motorista_ID"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="motortel"
            caption="Motor_Tel"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            sort-order="desc"
            data-field="id"
            caption="ID"
            alignment="left"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="status"
            caption="Status"
            alignment="left"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="inicio"
            caption="Início"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy hh:mm"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="nument"
            caption="Entrega"
            alignment="right"
            data-type="number"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="pedido"
            caption="Pedido"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="origem"
            caption="Origem"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="destino"
            caption="Destino"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="numto"
            caption="Número TO"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="rotalh"
            caption="Rota LH"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entrega"
            caption="Entrega"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entrgsto"
            caption="Entr_Sto"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entrglogter"
            caption="Entr_Log_Ter"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entrgorigem"
            caption="Entr_Origem"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entrgmotid"
            caption="Entr_MotId"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entrgmotor"
            caption="Entr_Motorista"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entrgcep"
            caption="Entr_CEP"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entrgveic"
            caption="Entr_Veículo"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entrgajuda"
            caption="Entr_Ajuda"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entrgdist"
            caption="Entr_Dist"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entrgrotaat"
            caption="Entr_RotaAt"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="slstrk"
            caption="SLS_Trk"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="shopsn"
            caption="Shopee_SN"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="latlong"
            caption="LatLong"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cep"
            caption="CEP"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="comprador"
            caption="Comprador"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="comprtel"
            caption="Telefone"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="rua"
            caption="Endereço"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tipo"
            caption="Tipo"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="recebido"
            caption="Recebido"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy hh:mm"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="recebestacao"
            caption="Receb_Estacao"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy hh:mm"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="entregares"
            caption="Entrega"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy hh:mm"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="espera"
            caption="Espera"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy hh:mm"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="espmotivo"
            caption="Espera_Motivo"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="conta"
            caption="Conta"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="origasf"
            caption="OrigSF"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tempespera"
            caption="Tem_Espera"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tententr"
            caption="Ten_Entrega"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="atualsto"
            caption="Atual_STO"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="destret"
            caption="Dest_Ret"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="lojaid"
            caption="Loja_ID"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="canal"
            caption="Canal"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="deststo"
            caption="Dest_STO"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="pkpsto"
            caption="PKP_STO"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="coleta"
            caption="Coleta"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy hh:mm"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="transsp"
            caption="Transp_SP"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy hh:mm"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="stname"
            caption="Station Name"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="agencia"
            caption="Agência"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="creator"
            caption="Criador"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="operator"
            caption="Operador"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="statusimp"
            caption="StatusImp"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cidade"
            caption="Cidade"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cluster"
            caption="Cluster"
            alignment="left"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>
      </DxDataGrid>
    </div>



  </Layout>


  <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
    <div class="col-md-12">
      <div class="mb-3">
        <label for="tipooperacao">Selecionar Data Inicial e Final</label>

      </div>
    </div>
    <div class="row">

      <div class="col-md-6">
        <div class="mb-3">
          <label for="dtIniFiltro">Data Início</label>
          <input
              id="dtIniFiltro"
              v-model="dtIniFiltro"
              type="date"
              class="form-control"
              placeholder="Data Início"
              :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
          <div v-if="submittedPeriodo && !dtIniFiltro"
               class="invalid-feedback">
            <span >Campo data início obrigatório, favor preencher.</span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-3">
          <label for="dtFimFiltro">Data Final</label>
          <input
              id="dtFimFiltro"
              v-model="dtFimFiltro"
              type="date"
              class="form-control"
              placeholder="Data Final"
              :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
          <div v-if="submittedPeriodo && !dtFimFiltro"
               class="invalid-feedback">
            <span >Campo data final obrigatória, favor preencher.</span>
          </div>
        </div>
      </div>

    </div>
    <div class="text-end mt-5">
      <b-button variant="light" @click="showModalPeriodo = false">
        <i class="bx bx-block font-size-16 align-middle me-2"></i>
        Cancelar
      </b-button>
      <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
        <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
        Confirmar
      </b-button>
    </div>
  </b-modal>


  <b-modal title="Importar Planilha" v-model="showModalImpPlan" centered hide-footer>
    <div>
      <div class="card-body">
        <h4 class="card-title">Selecionar planilha</h4>
        <DropZone @change="selectedFile" />
        <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
        <div v-if="submittedImpPlan && !dropzoneFile.name">
          <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
        </div>
      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalImpPlan = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confImpPlan">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </div>
  </b-modal>



  <b-modal size="xl"
           :title="'Detalhes Pedido Shopee (' + movShopeeTrkData.id + ')'"
           v-model="showModalConsShopee" centered hide-footer>
    <div>

      <div class="card">
        <div class="card-body">

          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-1
                 class="text-dark"
                 href="javascript: void(0);">
                Coleta
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
            <b-card-body>

              <div class="row">

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="id">ID</label>
                    <input id="id" v-model="movShopeeTrkData.id"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="ID"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="pedido">Pedido</label>
                    <input id="pedido" v-model="movShopeeTrkData.pedido"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Pedido"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="nument">Total Entregas</label>
                    <input id="nument" v-model="movShopeeTrkData.nument"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Total Entregas"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="statustrk">Status</label>
                    <input id="statustrk" v-model="movShopeeTrkData.status"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Status"/>
                  </div>
                </div>

              </div>
            </b-card-body>
          </b-collapse>


          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-2
                 class="text-dark"
                 href="javascript: void(0);">
                Entrega
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
            <b-card-body>

              <div class="row">

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="inicio">Início</label>
                    <input id="inicio" v-model="movShopeeTrkData.inicio"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Início"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="numto">Número da TO</label>
                    <input id="numto" v-model="movShopeeTrkData.numto"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Número da TO"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="rotalh">Rota de LH</label>
                    <input id="rotalh" v-model="movShopeeTrkData.rotalh"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Rota de LH"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="origem">Origem</label>
                    <input id="origem" v-model="movShopeeTrkData.origem"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Origem"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="destino">Destino</label>
                    <input id="destino" v-model="movShopeeTrkData.destino"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Destino"/>
                  </div>
                </div>

              </div>

            </b-card-body>
          </b-collapse>


          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-3
                 class="text-dark"
                 href="javascript: void(0);">
                Resumo
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">
            <b-card-body>

              <div class="row">

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="entrega">Entrega</label>
                    <input id="entrega" v-model="movShopeeTrkData.entrega"
                           type="text"
                           class="form-control"
                           :disabled="true"
                           placeholder="Entrega"/>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="entrgsto">Nome Station</label>
                    <input id="entrgsto" v-model="movShopeeTrkData.entrgsto"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Nome Station"/>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="entrglogter">3PL</label>
                    <input id="entrglogter" v-model="movShopeeTrkData.entrglogter"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="3PL"/>
                  </div>
                </div>


                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="entrgdist">Distância</label>
                    <input id="entrgdist" v-model="movShopeeTrkData.entrgdist"
                           type="text" class="form-control text-end"
                           :disabled="true"
                           placeholder="Distância"/>
                  </div>
                </div>

              </div>

              <div class="row">

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="entrgrotaat">Rota (AT)</label>
                    <input id="entrgrotaat" v-model="movShopeeTrkData.entrgrotaat"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Rota (AT)"/>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="entrgorigem">XD de Origem</label>
                    <input id="entrgorigem" v-model="movShopeeTrkData.entrgorigem"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="XD de Origem"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="entrgcep">CEP</label>
                    <input id="entrgcep" v-model="movShopeeTrkData.entrgcep"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="CEP"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="entrgveic">Veículo</label>
                    <input id="entrgveic" v-model="movShopeeTrkData.entrgveic"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Veículo"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="entrgajuda">Status Helper</label>
                    <input id="entrgajuda" v-model="movShopeeTrkData.entrgajuda"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Status Helper"/>
                  </div>
                </div>

              </div>

              <div class="row">

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="entrgmotid">ID Motorista</label>
                    <input id="entrgmotid" v-model="movShopeeTrkData.entrgmotid"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="ID Motorista"/>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="entrgmotor">Motorista</label>
                    <input id="entrgmotor" v-model="movShopeeTrkData.entrgmotor"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Motorista"/>
                  </div>
                </div>

              </div>


              <div class="row">

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="slstrk">SLS Tracking Number</label>
                    <input id="slstrk" v-model="movShopeeTrkData.slstrk"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="SLS Tracking Number"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="shopsn">Shopee Order SN</label>
                    <input id="shopsn" v-model="movShopeeTrkData.shopsn"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Shopee Order SN"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="latlong">Lat.Long.</label>
                    <input id="latlong" v-model="movShopeeTrkData.latlong"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Lat.Long."/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="cep">CEP</label>
                    <input id="cep" v-model="movShopeeTrkData.cep"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="CEP"/>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="comprador">Buyer Name</label>
                    <input id="comprador" v-model="movShopeeTrkData.comprador"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Buyer Name"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="comprtel">Buyer Phone</label>
                    <input id="comprtel" v-model="movShopeeTrkData.comprtel"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Buyer Phone"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="rua">Buyer Address</label>
                    <input id="rua" v-model="movShopeeTrkData.rua"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Buyer Address"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="tipo">Location Type</label>
                    <input id="tipo" v-model="movShopeeTrkData.tipo"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Location Type"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="motorista">Driver Name</label>
                    <input id="motorista" v-model="movShopeeTrkData.motorista"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Driver Name"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="motorid">Driver ID</label>
                    <input id="motorid" v-model="movShopeeTrkData.motorid"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Driver ID"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="motortel">Driver Phone</label>
                    <input id="motortel" v-model="movShopeeTrkData.motortel"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Driver Phone"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="recebido">Received Time</label>
                    <input id="recebido" v-model="movShopeeTrkData.recebido"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Received Time"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="recebestacao">Current Station Received Time</label>
                    <input id="recebestacao" v-model="movShopeeTrkData.recebestacao"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Current Station Received Time"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="entregares">Delivered Time</label>
                    <input id="entregares" v-model="movShopeeTrkData.entregares"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Delivered Time"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="espera">OnHold Time</label>
                    <input id="espera" v-model="movShopeeTrkData.espera"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="OnHold Time"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="espmotivo">OnHoldReason</label>
                    <input id="espmotivo" v-model="movShopeeTrkData.espmotivo"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="OnHoldReason"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="conta">Order Account</label>
                    <input id="conta" v-model="movShopeeTrkData.conta"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Order Account"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="origasf">Original ASF</label>
                    <input id="origasf" v-model="movShopeeTrkData.origasf"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Original ASF"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="tempespera">Total of On Hold Times</label>
                    <input id="tempespera" v-model="movShopeeTrkData.tempespera"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Total of On Hold Times"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="tententr">Delivery Attempts</label>
                    <input id="tententr" v-model="movShopeeTrkData.tententr"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Delivery Attempts"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="atualsto">Current Station</label>
                    <input id="atualsto" v-model="movShopeeTrkData.atualsto"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Current Station"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="destret">Return Destination</label>
                    <input id="destret" v-model="movShopeeTrkData.destret"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Return Destination"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="lojaid">Shop ID</label>
                    <input id="lojaid" v-model="movShopeeTrkData.lojaid"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Shop ID"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="canal">Channel</label>
                    <input id="canal" v-model="movShopeeTrkData.canal"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Channel"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="deststo">Destination Station</label>
                    <input id="deststo" v-model="movShopeeTrkData.deststo"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Destination Station"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="pkpsto">Pickup Station</label>
                    <input id="pkpsto" v-model="movShopeeTrkData.pkpsto"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Pickup Station"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="coleta">Pick Up Time</label>
                    <input id="coleta" v-model="movShopeeTrkData.coleta"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Pick Up Time"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="transsp">Transported to sp time</label>
                    <input id="transsp" v-model="movShopeeTrkData.transsp"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Transported to sp time"/>
                  </div>
                </div>

              </div>

            </b-card-body>
          </b-collapse>



          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-4
                 class="text-dark"
                 href="javascript: void(0);">
                Apuração
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
            <b-card-body>

              <div class="row">

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="taskid">Task ID</label>
                    <input id="taskid" v-model="movShopeeTrkData.taskid"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Task ID"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="stname">ST. Name</label>
                    <input id="stname" v-model="movShopeeTrkData.stname"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="ST. Name"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="agencia">Agência</label>
                    <input id="agencia" v-model="movShopeeTrkData.agencia"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Agência"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="creator">Creator</label>
                    <input id="creator" v-model="movShopeeTrkData.creator"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Creator"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="operator">Operator</label>
                    <input id="operator" v-model="movShopeeTrkData.operator"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Operator"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="statusimp">Status</label>
                    <input id="statusimp" v-model="movShopeeTrkData.statusimp"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Status"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="cidade">Cidade</label>
                    <input id="cidade" v-model="movShopeeTrkData.cidade"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Cidade"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="cluster">Cluster</label>
                    <input id="cluster" v-model="movShopeeTrkData.cluster"
                           type="text" class="form-control"
                           :disabled="true"
                           placeholder="Cluster"/>
                  </div>
                </div>

              </div>

            </b-card-body>
          </b-collapse>


          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-5
                 class="text-dark"
                 href="javascript: void(0);">
                Financeiro
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-5" visible accordion="my-accordion-5" role="tabpanel">
            <b-card-body>

              <div class="table-responsive">
                <table
                    class="table align-middle table-nowrap table-hover mb-0">
                  <thead>
                  <tr>
                    <th scope="col">Data</th>
                    <th scope="col">Tipo</th>
                    <th scope="col">Placa</th>
                    <th scope="col">TO</th>
                    <th scope="col" class="text-end">Remessas</th>
                    <th scope="col" class="text-end">Entregue</th>
                    <th scope="col" class="text-end">Insucessos</th>
                    <th scope="col" class="text-end">Eficácia</th>
                    <th scope="col">Obs</th>
                    <th scope="col" class="text-end">Valor Veic.</th>
                    <th scope="col" class="text-end">Variável</th>
                    <th scope="col" class="text-end">Valor Efic.</th>
                    <th scope="col" class="text-end">Valor Ad1</th>
                    <th scope="col" class="text-end">Valor Ad2</th>
                    <th scope="col" class="text-end text-black">Total</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in movSpeTrkFinancs" :key="data.id">

                    <td class="">{{ formatDate(data.data) }}</td>
                    <td class="">{{ data.tipo }}</td>
                    <td class="">{{ data.placa }}</td>
                    <td class="">{{ data.taskid }}</td>
                    <td class="text-end">{{ formatInteger(data.remessa) }}</td>
                    <td class="text-end">{{ formatInteger(data.entrega) }}</td>
                    <td class="text-end">{{ formatInteger(data.falha) }}</td>
                    <td class="text-end">{{ formatDecimal(data.eficacia) }}</td>
                    <td class="">{{ data.obs }}</td>
                    <td class="text-end">{{ formatDecimal(data.valorveic) }}</td>
                    <td class="text-end">{{ formatDecimal(data.valor) }}</td>
                    <td class="text-end">{{ formatDecimal(data.valorefic) }}</td>
                    <td class="text-end">{{ formatDecimal(data.valoradic1) }}</td>
                    <td class="text-end">{{ formatDecimal(data.valoradic2) }}</td>

                    <td class="text-end text-black"> {{ formatDecimal(data.total) }}</td>

                  </tr>
                  </tbody>
                </table>
              </div>




            </b-card-body>
          </b-collapse>


        </div>
      </div>


      <Loader v-if="updatingShopee" style="min-height: 200px;">
      </Loader>



      <div class="row">
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalConsShopee = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

          <b-button variant="primary" @click="consShopee(movShopeeTrkData.id)" v-if="!updatingShopee">
            <i class="bx bx-search font-size-16 align-middle me-2"></i>
            Consultar Shopee
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" v-if="arqDispDownload" @click="downloadArq">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Download CT-e
          </b-button>
        </div>
      </div>
    </div>


  </b-modal>


  <b-modal title="Período de Cálculo" v-model="showModalPerFecha" centered hide-footer>
    <div class="col-md-12">
      <div class="mb-3">
        <label for="tipooperacao">Selecionar Data Inicial e Final do cálculo</label>

      </div>
    </div>
    <div class="row">

      <div class="col-md-6">
        <div class="mb-3">
          <label for="dtIniPerFecha">Data Início</label>
          <input
              id="dtIniPerFecha"
              v-model="dtIniPerFecha"
              type="date"
              class="form-control"
              placeholder="Data Início"
              :class="{'is-invalid': submittedPerFecha && !dtIniPerFecha,}"/>
          <div v-if="submittedPerFecha && !dtIniPerFecha"
               class="invalid-feedback">
            <span >Campo data início obrigatório, favor preencher.</span>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="mb-3">
          <label for="dtFimPerFecha">Data Final</label>
          <input
              id="dtFimPerFecha"
              v-model="dtFimPerFecha"
              type="date"
              class="form-control"
              placeholder="Data Final"
              :class="{'is-invalid': submittedPerFecha && !dtFimPerFecha,}"/>
          <div v-if="submittedPerFecha && !dtFimPerFecha"
               class="invalid-feedback">
            <span >Campo data final obrigatória, favor preencher.</span>
          </div>
        </div>
      </div>

    </div>
    <div class="text-end mt-5">
      <b-button variant="light" @click="showModalPerFecha = false">
        <i class="bx bx-block font-size-16 align-middle me-2"></i>
        Cancelar
      </b-button>
      <b-button type="submit" variant="success" class="ms-1" @click="confirmarPerFecha">
        <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
        Confirmar
      </b-button>
    </div>
  </b-modal>



</template>
